export default {
  id: 221,
  title: 'Target #221 - Entangled',
  url: 'https://cssbattle.dev/play/221',
  colors: ['#3F4869', '#E25C57', '#F4DA64'],
  solution:
    '<p a><p b><style>p[a],p[b]{top:60;width:180}body{background:#3f4869}p{position:fixed;margin:0}p[a]{left:60;height:180;background:#f4da64;border-radius:1in;box-shadow:100px 0 #e25c57}p[b]{left:160;height:90;background:#e25c57;border-radius:1in 1in 0 0',
}
